import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { HOST_API_URL } from '../../../../config-global';
import { useTabs } from '../../../../context/TabContext';
import { useSelector } from '../../../../redux/store';
import { AwaitButton } from '../../../../reusable-components/await-button';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import { ORDER_HISTORY } from '../../../../reusable-components/datagrid/catalogColumns';
import Iconify from "../../../../reusable-components/iconify";

OrderHistory.propTypes = {
  data: PropTypes.array,
  preSearchVendorItemId: PropTypes.string,
  productId: PropTypes.number
};

export default function OrderHistory({ data, preSearchVendorItemId, productId }) {
  const { id = '' } = useParams();
  const isLoading = useSelector((state) => state.catalog.isLoading);
  const { orderById } = useSelector((state) => state.orders);
  const { addNewTabAndNavigate } = useTabs();


  const CustomLeftToolbar = () =>
    <Grid container direction="row" justifyContent="flex-start" alignItems="flex-end">
      <AwaitButton
        variant="outlined"
        sx={{ mr: 1 }}
        size="small"
        color="secondary"
        onClick={() => window.open(`${HOST_API_URL}Api/DownloadProductOrderHistory?productId=${productId}`, '_blank')}
        startIcon={<Iconify icon="file-icons:microsoft-excel" />}
      >
        Download
      </AwaitButton>
    </Grid>

  return (
    <div>
      <Grid item xs={12}>
        <CustomDataGrid
          gridId="admin-catalog-order-history"
          boxSX={{ width: '100%', height: 'calc(100vh - 260px)' }}
          data={data}
          presetFilter={`${preSearchVendorItemId || ''} ${orderById[id]?.facility || ''}`}
          gridColumns={ORDER_HISTORY}
          isModal
          isLoading={!data.length && isLoading}
          CustomLeftToolbar={CustomLeftToolbar}
          onRowClick={(params) => {
            const selection = window.getSelection().toString();
            if (selection.length > 0) return;
            addNewTabAndNavigate(`/dashboard/orders/${params.row.orderNumber.replace(/\D/g, '')}`);
          }}
        />
      </Grid>
    </div>
  );
}
